export const ENDPOINT = "https://wscu-dev.dance4water.org/api/v1/";
// export const ENDPOINT = "http://127.0.0.1:5000/api/v1/";